/*!
 * mtj-builder-v2.js : "Build your Momento" 3-step configurator (v2 PDP)
 * Forward-facing builder layer. Drives the native Impact variant-picker under
 * the hood (option1=Size, option2=Color) so price + ATC stay correct, renders
 * to-scale journal icons with live recolor, two-slot Pair logic, and gates the
 * existing charm engine ([data-mtj-charm-conf]) behind a reveal + confetti.
 * Charm selection/stamping is unchanged: we only re-skin and reveal it.
 */
(function () {
  "use strict";
  var HANDLE = "ilovehue-momento-traveler-s-journal";
  var D = (window.MTJ_V2_DATA || { variants: [], symbol: "$" });
  var SYM = D.symbol || "$";
  var root = document.getElementById("mtj-builder");
  if (!root || root.__mtjbInit) return;
  root.__mtjbInit = true;

  // ---- approximate swatch colors for the live icon preview (abstract icon) ----
  var COLOR_HEX = {
    Bordeaux: "#6e2433", Obsidian: "#1d1d1f", Midnight: "#23304f",
    Ochre: "#b9772d", Moss: "#5c6a44", Mocha: "#6b4f3b", Lacy: "#d9cfbe"
  };

  // ---- model from real variant data ----
  var V = D.variants || [];
  var SIZES = [];
  V.forEach(function (v) { if (SIZES.indexOf(v.size) === -1) SIZES.push(v.size); });
  var COLORS = [];
  V.forEach(function (v) { if (COLORS.indexOf(v.color) === -1) COLORS.push(v.color); });
  function variant(size, color) {
    for (var i = 0; i < V.length; i++) if (V[i].size === size && V[i].color === color) return V[i];
    return null;
  }
  function basePrice(size) { // lowest (non-premium) price for the size card
    var p = null;
    V.forEach(function (v) { if (v.size === size && (p === null || v.price < p)) p = v.price; });
    return p;
  }
  function fmt(cents) { var a = cents / 100; return SYM + (a % 1 === 0 ? a.toFixed(0) : a.toFixed(2)); }

  var SIZE_META = {
    Pocket:  { dim: '4" x 7"',  w: 44,  h: 66,   support: "Always by your side. Slips into a back pocket or a jacket." },
    Classic: { dim: '5" x 8"',  w: 50,  h: 74,   support: "Room to think. Sits like a paperback in your tote." }
  };
  var PAIR_SUPPORT = "The complete set. One to carry, one to keep at home.";
  var INSERTS_LINE = "3 inserts pre-installed for your convenience";

  // ---- state ----
  var st = { mode: "single", size: null, color: null, pair: [null, null], pairSlot: 0, step: 1, revealed: false };

  // ===================== native variant-picker driver =====================
  function picker() { return document.querySelector('variant-picker[handle="' + HANDLE + '"]'); }
  function setOption(position, valueText) {
    var p = picker(); if (!p) return false;
    // match the option label whose text equals valueText, click its input
    var labels = p.querySelectorAll('label,.block-swatch,.swatch-input__label,[data-option-value]');
    for (var i = 0; i < labels.length; i++) {
      var t = (labels[i].textContent || "").trim();
      // for size we match Pocket/Classic; for color exact-ish
      if (t === valueText || new RegExp("(^|\\s)" + valueText + "(\\s|$)", "i").test(t)) {
        var input = null, forId = labels[i].getAttribute("for");
        if (forId) input = document.getElementById(forId);
        if (!input) input = labels[i].querySelector('input[type="radio"]');
        if (!input) {
          var prev = labels[i].previousElementSibling;
          if (prev && prev.matches && prev.matches('input[type="radio"]')) input = prev;
        }
        var posOk = !input || !input.name || input.name.indexOf("option" + position) !== -1;
        if (input && posOk) {
          if (!input.checked) { input.checked = true; input.dispatchEvent(new Event("change", { bubbles: true })); }
          else { input.dispatchEvent(new Event("change", { bubbles: true })); }
          try { labels[i].click(); } catch (e) {}
          return true;
        }
      }
    }
    return false;
  }
  function applySelection() {
    // Clicking the native radio labels steals focus and the browser scrolls them
    // into view, yanking the page. Lock scroll position across the clicks.
    var sx = window.scrollX, sy = window.scrollY;
    var lock = function () { if (window.scrollX !== sx || window.scrollY !== sy) window.scrollTo(sx, sy); };
    if (st.mode === "single") {
      if (st.size) setOption(1, st.size);
      if (st.color) setOption(2, st.color);
    } else {
      // Pair: drive picker to Pocket + slot-1 color so the visible price/ATC
      // reflect at least one journal; real two-line add handled on ATC intercept.
      if (st.pair[0]) { setOption(1, "Pocket"); setOption(2, st.pair[0]); }
    }
    lock();
    requestAnimationFrame(lock);
    setTimeout(lock, 0);
  }

  // ===================== icon =====================
  // Momento silhouette (true to the product): portrait leather cover with
  // rounded corners, a HORIZONTAL elastic band across the middle, a small
  // closure tab on the right edge, and two gold charms hanging off the band.
  function journalSVG(w, h, hex, id) {
    // Real Momento product photo, recolored per swatch (size conveys Pocket vs Classic).
    var m = window.MTJ_SIZE_ICONS || {};
    var u = m[(hex || "").toLowerCase()] || window.MTJ_SIZE_ICON || "";
    return '<img class="mtjb-photo" src="' + u + '" alt="" decoding="async" style="display:block;height:' + h + 'px;width:auto;margin:0 auto;pointer-events:none;" />';
  }
  function shade(hex, pct) {
    var n = parseInt(hex.slice(1), 16), r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    function c(x) { return Math.max(0, Math.min(255, Math.round(x + (x * pct / 100)))); }
    return "#" + ((1 << 24) + (c(r) << 16) + (c(g) << 8) + c(b)).toString(16).slice(1);
  }

  // ===================== render =====================
  function el(html) { var d = document.createElement("div"); d.innerHTML = html.trim(); return d.firstChild; }

  function render() {
    root.innerHTML = "";
    root.appendChild(stepBar());
    root.appendChild(stepSize());
    root.appendChild(stepColor());
    root.appendChild(stepCharms());
    paint();
  }

  function stepBar() {
    var names = ["Size", "Color", "Charms"];
    var h = '<div class="mtjb-steps">';
    for (var i = 0; i < 3; i++) h += '<div class="mtjb-step" data-step="' + (i + 1) + '"><span class="mtjb-step__l">' + names[i] + '</span></div>';
    h += '</div>';
    return el('<div class="mtjb-head"><div class="mtjb-title">Build your Momento</div>' + h + '</div>');
  }

  function sizeCard(size) {
    var m = SIZE_META[size]; if (!m) return "";
    return '<button type="button" class="mtjb-card mtjb-card--size" data-size="' + size + '">' +
      '<div class="mtjb-card__icon" data-iconwrap="' + size + '">' + journalSVG(m.w, m.h, "#cdb89a", size) + '</div>' +
      '<div class="mtjb-card__name">' + size + '</div>' +
      '<div class="mtjb-card__dim">' + m.dim + '</div>' +
      '<div class="mtjb-card__price">' + fmt(basePrice(size)) + '</div>' +
      '</button>';
  }

  function pairMath() {
    var pocket = basePrice("Pocket"), classic = basePrice("Classic");
    var total = pocket + classic;                      // post-discount prices already
    var capP = (variant("Pocket", "Bordeaux") || {}).compare || Math.round(pocket / 0.8);
    var capC = (variant("Classic", "Bordeaux") || {}).compare || Math.round(classic / 0.8);
    var capTotal = capP + capC;
    var each = Math.round(total / 2);
    var save = capTotal - total;
    return { total: total, each: each, save: save, capTotal: capTotal };
  }

  function pairCard() {
    var pm = pairMath();
    return '<button type="button" class="mtjb-card mtjb-card--pair" data-size="Pair">' +
      '<div class="mtjb-pair-icons">' + journalSVG(34, 58, "#cdb89a", "pA") + journalSVG(40, 66, "#cdb89a", "pB") + '</div>' +
      '<div class="mtjb-pair-body">' +
        '<div class="mtjb-card__name">The Pair</div>' +
        '<div class="mtjb-pair-math"><span class="mtjb-pair-total">' + fmt(pm.total) + '</span>' +
          (pm.capTotal > pm.total ? '<span class="mtjb-pair-strike">' + fmt(pm.capTotal) + '</span>' : '') + '</div>' +
        (pm.save > 0 ? '<div class="mtjb-pair-save">Save ' + fmt(pm.save) + '</div>' : '') +
      '</div>' +
      '</button>';
  }

  function stepSize() {
    var h = '<div class="mtjb-sec" data-sec="1"><div class="mtjb-sec__label">Choose your size</div>' +
      '<div class="mtjb-size-grid">' + sizeCard("Pocket") + sizeCard("Classic") + pairCard() + '</div>' +
      '<div class="mtjb-size-copy" data-sizecopy hidden></div>' + '</div>';
    return el(h);
  }

  function stepColor() {
    var h = '<div class="mtjb-sec mtjb-sec--locked" data-sec="2"><div class="mtjb-sec__label">Choose your color</div>' +
      '<div class="mtjb-pair-slots" data-pairslots hidden><button type="button" class="mtjb-slot is-active" data-slot="0">Pocket<span></span></button>' +
      '<button type="button" class="mtjb-slot" data-slot="1">Classic<span></span></button></div>' +
      '<div class="mtjb-swatches" data-swatches>';
    COLORS.forEach(function (c) {
      var hex = COLOR_HEX[c] || "#ccc";
      h += '<button type="button" class="mtjb-swatch" data-color="' + c + '" title="' + c + '"><span class="mtjb-swatch__dot" style="background:' + hex + '"></span><span class="mtjb-swatch__name">' + c + '</span></button>';
    });
    h += '</div></div>';
    return el(h);
  }

  function stepCharms() {
    // The reveal itself now lives as an overlay on the charm configurator below
    // (see updateCharmGate); this is just the step lead-in.
    return el('<div class="mtjb-sec mtjb-sec--locked" data-sec="3"><div class="mtjb-sec__label">Your free charms</div>' +
      '<div class="mtjb-charmval">A gold-plated charm, included free.</div>' +
      '</div>');
  }

  // ===================== paint state -> DOM =====================
  function paint() {
    // step bar
    root.querySelectorAll(".mtjb-step").forEach(function (s) {
      var n = +s.getAttribute("data-step");
      s.classList.toggle("is-done", n < st.step);
      s.classList.toggle("is-active", n === st.step);
    });
    // size selection
    root.querySelectorAll(".mtjb-card--size,.mtjb-card--pair").forEach(function (c) {
      var sz = c.getAttribute("data-size");
      var on = (st.mode === "single" && sz === st.size) || (st.mode === "pair" && sz === "Pair");
      c.classList.toggle("is-sel", on);
      c.classList.toggle("is-oos", st.color === "Lacy" && sz !== "Pocket");
    });
    // unlock color + charms once size chosen
    var hasSize = st.mode === "pair" || !!st.size;
    sec(2).classList.toggle("mtjb-sec--locked", !hasSize);
    // pair slots visibility
    var slots = root.querySelector("[data-pairslots]");
    if (slots) slots.hidden = st.mode !== "pair";
    // color selection highlight
    root.querySelectorAll(".mtjb-swatch").forEach(function (b) {
      var col = b.getAttribute("data-color");
      var on = (st.mode === "single" && col === st.color) ||
        (st.mode === "pair" && (col === st.pair[0] || col === st.pair[1]));
      b.classList.toggle("is-sel", on);
    });
    // charms unlock once a color is set
    var hasColor = st.mode === "single" ? !!st.color : !!st.pair[0];
    sec(3).classList.toggle("mtjb-sec--locked", !hasColor);
    updateCharmGate(hasColor);
    // recolor icons
    recolor();
    // support copy: fades in BELOW the size grid once a size is chosen
    var copy = root.querySelector("[data-sizecopy]");
    if (copy) {
      var html = "";
      if (st.mode === "pair") {
        html = PAIR_SUPPORT + '<span class="mtjb-size-copy__inserts">' + INSERTS_LINE + "</span>";
      } else if (st.size && SIZE_META[st.size]) {
        html = SIZE_META[st.size].support + '<span class="mtjb-size-copy__inserts">' + INSERTS_LINE + "</span>";
      }
      if (html) {
        copy.innerHTML = html;
        copy.hidden = false;
        copy.classList.remove("in"); void copy.offsetWidth; copy.classList.add("in");
      } else {
        copy.hidden = true;
        copy.classList.remove("in");
      }
    }
    // pair slot active
    root.querySelectorAll(".mtjb-slot").forEach(function (s) {
      s.classList.toggle("is-active", +s.getAttribute("data-slot") === st.pairSlot);
      var col = st.pair[+s.getAttribute("data-slot")];
      s.querySelector("span").textContent = col ? (": " + col) : "";
    });
  }
  function sec(n) { return root.querySelector('[data-sec="' + n + '"]'); }

  function recolor() {
    if (st.mode === "single" && st.size && st.color) {
      var wrap = root.querySelector('[data-iconwrap="' + st.size + '"]');
      var m = SIZE_META[st.size];
      if (wrap) wrap.innerHTML = journalSVG(m.w, m.h, COLOR_HEX[st.color] || "#cdb89a", st.size + "s");
    } else if (st.mode === "single" && st.size) {
      var w2 = root.querySelector('[data-iconwrap="' + st.size + '"]');
      var mm = SIZE_META[st.size];
      if (w2 && !st.color) w2.innerHTML = journalSVG(mm.w, mm.h, "#cdb89a", st.size + "x");
    }
    if (st.mode === "pair") {
      var pw = root.querySelector(".mtjb-pair-icons");
      if (pw) pw.innerHTML = journalSVG(34, 58, COLOR_HEX[st.pair[0]] || "#cdb89a", "pA") + journalSVG(40, 66, COLOR_HEX[st.pair[1]] || "#cdb89a", "pB");
    }
  }

  // ===================== interactions =====================
  root.addEventListener("click", function (e) {
    var card = e.target.closest(".mtjb-card--size,.mtjb-card--pair");
    if (card) {
      var sz = card.getAttribute("data-size");
      if (st.color === "Lacy" && sz !== "Pocket") { return; } // Lacy is Pocket-only
      if (sz === "Pair") { st.mode = "pair"; st.size = null; st.pairSlot = 0; }
      else { st.mode = "single"; st.size = sz; }
      st.step = 2;
      applySelection(); paint();
      return;
    }
    var slot = e.target.closest(".mtjb-slot");
    if (slot) { st.pairSlot = +slot.getAttribute("data-slot"); paint(); return; }
    var sw = e.target.closest(".mtjb-swatch");
    if (sw) {
      var col = sw.getAttribute("data-color");
      if (col === "Lacy") { st.mode = "single"; st.size = "Pocket"; st.pair = [null, null]; st.pairSlot = 0; } // Lacy: Pocket only
      if (st.mode === "single") { st.color = col; }
      else {
        st.pair[st.pairSlot] = col;
        st.pairSlot = (st.pairSlot === 0 && !st.pair[1]) ? 1 : st.pairSlot;
      }
      st.step = 3;
      applySelection(); paint();
      return;
    }
  });

  // ===================== Pair add-to-cart (batched two-line) =====================
  // The Pair has no bundle SKU, so it ships as two journal lines (Pocket +
  // Classic) plus the two complimentary charm lines, in one batched /cart/add.js.
  // Mirrors sections/mtj-pair-picker.liquid (the canonical v1 Pair flow).
  var COMP_CHARMS = [
    { id: 47797557002461, slot: "complimentary_1" }, // Butterfly - 18k Gold Plated
    { id: 48016611836125, slot: "complimentary_2" }  // Mariposa Charm
  ];
  function pairReady() { return st.mode === "pair" && !!st.pair[0] && !!st.pair[1]; }
  function addPairToCart() {
    var p = variant("Pocket", st.pair[0]), c = variant("Classic", st.pair[1]);
    if (!p || !p.id || !c || !c.id) return false;
    var items = [{ id: p.id, quantity: 1 }, { id: c.id, quantity: 1 }];
    COMP_CHARMS.forEach(function (ch) { items.push({ id: ch.id, quantity: 1, properties: { _mtj_charm_slot: ch.slot } }); });
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(rootUrl + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error("cart_add_failed_" + r.status); return r.json(); })
      .then(function () { window.location.href = rootUrl + "cart"; })
      .catch(function (err) { try { console.warn("[mtjb pair]", err); } catch (e) {} });
    return true;
  }
  // Intercept the product form submit while in a completed Pair selection.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form && form.matches && form.matches("form.shopify-product-form") && pairReady()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addPairToCart();
    }
  }, true);

  // ===================== charm reveal overlay + confetti =====================
  function charmEl() { return document.querySelector("[data-mtj-charm-conf]"); }

  // Gate the charm configurator behind a frosted overlay button. Once size+color
  // are chosen the engine is unlocked and shown (blurred behind the overlay);
  // clicking the overlay button confettis in place and reveals the charms.
  function updateCharmGate(hasColor) {
    var charm = charmEl(); if (!charm) return;
    if (st.revealed) {
      var done = charm.querySelector(".mtjb-charm-overlay"); if (done) done.remove();
      charm.classList.remove("mtjb-charm-armed");
      charm.classList.add("mtjb-charm-reskinned");
      return;
    }
    if (hasColor) {
      charm.removeAttribute("hidden");
      charm.classList.add("mtjb-charm-armed");
      if (!charm.querySelector(".mtjb-charm-overlay")) {
        var ov = el('<div class="mtjb-charm-overlay" data-charm-overlay>' +
          '<div class="mtjb-charm-overlay__inner">' +
          '<div class="mtjb-charm-overlay__val">A gold-plated charm, included free</div>' +
          '<button type="button" class="mtjb-reveal" data-reveal>Reveal my free charm</button>' +
          '</div></div>');
        charm.appendChild(ov);
        ov.querySelector("[data-reveal]").addEventListener("click", function () { doReveal(this); });
      }
    } else {
      charm.classList.remove("mtjb-charm-armed");
      var ov2 = charm.querySelector(".mtjb-charm-overlay"); if (ov2) ov2.remove();
    }
  }

  function doReveal(btn) {
    if (btn.disabled) return;
    btn.disabled = true; btn.classList.add("is-pulsing"); btn.textContent = "Unlocking\u2026";
    var charm = charmEl();
    setTimeout(function () {
      // Complete the unlock FIRST so the configurator can never stay gated if
      // the celebration animation throws on any device.
      st.revealed = true;
      var ov = charm && charm.querySelector(".mtjb-charm-overlay");
      if (ov) { ov.classList.add("is-out"); setTimeout(function () { if (ov.parentNode) ov.remove(); }, 480); }
      if (charm) {
        charm.classList.remove("mtjb-charm-armed");
        charm.classList.add("mtjb-charm-reskinned");
        try { charm.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
      }
      try { if (charm) confettiIn(charm); } catch (e) {}
    }, 350);
  }

  // Confetti scoped to the configurator: an absolute canvas over the element,
  // bursting from its center, so the celebration happens inside the box.
  function confettiIn(container) {
    var w = container.clientWidth, h = container.clientHeight;
    if (!w || !h) return;
    var cv = document.createElement("canvas");
    cv.className = "mtjb-confetti-in"; cv.width = w; cv.height = h;
    cv.style.cssText = "position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:7";
    container.appendChild(cv);
    var ctx = cv.getContext("2d"), parts = [], cols = ["#0A5CB8", "#6aa8ff", "#b9772d", "#5c6a44", "#6e2433", "#d8c9a8"];
    var cx = w / 2, cy = h / 2;
    for (var i = 0; i < 72; i++) {
      var a = Math.random() * Math.PI * 2, sp = 3 + Math.random() * 6;
      parts.push({ x: cx, y: cy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 3, g: 0.16 + Math.random() * 0.1, s: 4 + Math.random() * 4, c: cols[i % cols.length], r: Math.random() * 6, vr: (Math.random() - 0.5) * 0.4, life: 1 });
    }
    var t0 = performance.now();
    (function loop(t) {
      t0 = t;
      ctx.clearRect(0, 0, cv.width, cv.height);
      var alive = false;
      parts.forEach(function (p) {
        p.vy += p.g; p.x += p.vx; p.y += p.vy; p.r += p.vr; p.life -= 0.01;
        if (p.life > 0 && p.y < cv.height + 20) {
          alive = true; ctx.save(); ctx.globalAlpha = Math.max(0, p.life);
          ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c;
          ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6); ctx.restore();
        }
      });
      if (alive) requestAnimationFrame(loop); else cv.remove();
    })(t0);
  }

  // boot
  if (!V.length) { root.innerHTML = '<div class="mtjb-err">Builder data unavailable.</div>'; return; }
  render();
  // keep native picker hidden but present
  var p = picker(); if (p) p.classList.add("mtjb-hide-native");
})();

